
import { MeetingActionTypes, MeetingActions } from './Meeting/actions';
import { ModalsActionTypes, ModalsActions } from './Modals/actions';
import { SnackbarsActionTypes, SnackbarsActions } from './Snackbars/actions';

export const ACTION_STATUSES = {
  FAIL: {
    status: 'FAIL',
  },
  REQUEST: {
    status: 'REQUEST',
  },
  SUCCESS: {
    status: 'SUCCESS',
  },
};

const requestError = (type, error) => ({
  type,
  error,
  ...ACTION_STATUSES.FAIL,
});

const requestStart = (type) => ({
  type,
  ...ACTION_STATUSES.REQUEST,
});

const requestReceive = (type, payload) => (dispatch) => {
  dispatch({
    type,
    payload,
    ...ACTION_STATUSES.SUCCESS,
  });
};

export const ACTION_TYPES = {
  STORE_RESET: 'STORE_RESET',
  ...MeetingActionTypes,
  ...ModalsActionTypes,
  ...SnackbarsActionTypes,
};

const storeReset = () => ({
  type: ACTION_TYPES.STORE_RESET,
});

export const actions = {
  storeReset,
  requestError,
  requestStart,
  requestReceive,
  ...MeetingActions,
  ...ModalsActions,
  ...SnackbarsActions,
};
